<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>
        <a href="javascript:void(0);" (click)="goBack()" class="back">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </a>
        {{'Event Summary' | translate}}
      </h1>
    </div>
    <div class="page-filter clearfix multiple-filter">
      <div class="filter-flex">
        <div class="filter">
          <div class="filter-list name_title">
            <div class="filter-content">
              <p-multiSelect [options]="(deviceSubtypeOptions)" [(ngModel)]="DeviceSubType" placeholder="{{'Choose' | translate}}" (onChange)="dispatchFilter(0,selectedDevice,$event)" [filter]="false" [maxSelectedLabels]="4">
              </p-multiSelect>
            </div>
          </div>
          <div class="filter-list name_title">
            <div class="filter-content">
              <p-select [options]="deviceOptions" [(ngModel)]="selectedDevice" (onChange)="dispatchFilter('filter',$event,DeviceSubType)" [style]="{'width':'100%'}" placeholder="{{'Select Device' | translate}}">
                <ng-template pTemplate="item" let-item>
                  {{item.label | translate}}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{item.label | translate}}
                </ng-template>
              </p-select>
            </div>
          </div>
        </div>
        <div class="filter search float-right">
          <div class="button">
            <!-- <input #gb type="text" pInputText placeholder="Search" class="pInputText"> -->
            <input type="text" pInputText placeholder="{{'Search' | translate}}" (input)="dt.filterGlobal($event.target.value, 'contains')" class="pInputText">
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <p-table #dt [value]="eventSummary" [columns]="cols" class="deviceTable pageAllOptions"  [paginator]="true" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20,{showAll:'All'}]"
      [scrollable]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
              {{col.header | translate}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td style="width: 200px" class="col-nowrap">{{rowData.name}}</td>
            <td style="width: 200px" class="col-nowrap">{{rowData.time}}</td>
            <td style="width: 150px" class="">{{rowData.timezone}}</td>
            <td style="width: 450px" class="col-nowrap">{{ rowData.desc | statusEventTranslate | async }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="cols.length">
              <div translate class="ui-emptymessage">No Event found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
